import React from 'react'
import {
  BrowserRouter as Router,
  Route, Switch
} from 'react-router-dom'
import Loadable from 'react-loadable';
import Loading from './Loading';
import { Nav } from './Nav';

const About = () => (
  <div>
    <h2>About</h2>
  </div>
)

const NoMatch = ({ location }) => (
	<div style={{padding:'2em'}}>
		<h2>
			No match for <code>{location.pathname}</code>
		</h2>
		<p>Use the search box or navigation menu to find what you are looking for.</p>
	</div>
)

const App = () => (
	<Router>
		<div>
			<Nav />
			<Switch>
				<Route exact path="/" component={Loadable({
					loader: () => import('./home/Home.js'),
					loading:Loading,
				})}/>
				<Route path="/about" component={About}/>
				<Route path="/passgen" component={Loadable({
					loader: () => import('./pages/passgen/Passgen.js'),
					loading:Loading,
					})}/>
				<Route path="/posts" component={Loadable({
					loader: () => import('./posts/Posts.js'),
					loading:Loading,
					})}/>
				<Route component={NoMatch} />
			</Switch>
		</div>
	</Router>
)
export default App


// WEBPACK FOOTER //
// ./src/App.js